export const API_URL="https://carsharing.sennrueti.ch:8000"
